import { UUID } from '../../basetypes';
export enum ProductTypeEnum {
    Ticket,
    PrepaidCard,
    MembershipCard,
    Product,
    Donation
}

export type ProductModel = {
    ProductType: ProductTypeEnum,
    IsPackageProduct: boolean,
    ShowOnlyWholePackagePricesOnInternet: boolean,
    ClientID: number,
    EventID: number,
    PackageID: number,
    ProducerID: number,
    EventDateID: number,
    EventDateCode: string,
    RepresentationTypeName: string,
    OwnerPOSID: number,
    Name: string,
    Description1: string,
    Description2: string,
    Date: Date,
    Date_DateTimeAndTzString: string,
    PhysicalVenueName: string,
    VenueName: string,
    VenueAddress: string,
    VenuePhone: string,
    TicketPickupConfirmationMessage: string,
    TicketPickupPlaceName: string,
    TicketPickupPlacePhone: string,
    HideEventDate: boolean,
    IsSentByMail: boolean,
    IsSentByETicket: boolean,
    ShippingFee: number,
    ShippingFeeBeforeTaxes: number,
    Total: number,
    TotalTicketPriceAndFeesBeforeTaxes: number,
    TotalTicketAndFeesTaxes: number,
    TotalTicketQty: number,
    ETicketShare: ETicketShare,
    ETicketShareURL: string,
    ETicketAutoSendingSuspended: boolean,
    LinkToPurchasedEvent: string,
    DeliveryMessage: DeliveryMessageResponse,
    VenueLocationString: string,
    Description1AutoHide: string,
    Description2AutoHide: string,
    ProductInstances: ProductInstanceModel,
    ActualSubProducts: ProductModel[],
    ShippingFeeId: UUID,
}

export type ETicketShare = {
    ID: string,
    FromShareID: string,
    OrderID: number,
    RecipientEmailAddress: string
}

export type DeliveryMessageResponse = {
    message: string,
    isMarkdown: boolean
}

export type ProductInstanceModel = {
    Name: string,
    ProductOrCardNumber: string,
    PriceName: string,
    Price: number,
    Fees: number,
    Total: number,
    PriceBeforeTaxes: number,
    FeesBeforeTaxes: number,
    TotalBeforeTaxes: number,
    TotalPriceBeforeTaxes: number,
    TotalFeesBeforeTaxes: number,
    TotalTicketPriceAndFeesBeforeTaxes: number,
    TotalTicketAndFeesTaxes: number,
    TicketDateOverride: Date,
    TicketDateOverride_DateTimeString: string
}